import axiosInstance from '../../services/axiosMiddleware';

export async function createPranayamma(pranyammaData) {
  try {
    const response = await axiosInstance.post('pranayamma/createPranayamma', pranyammaData);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
